"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TypeDisplay = void 0;
var _react = _interopRequireDefault(require("react"));
var _Stamp = require("../../utils/components/Stamp");
var _alloyReactTooltip = _interopRequireWildcard(require("@adsk/alloy-react-tooltip"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const TypeDisplay = _ref => {
  let {
    status,
    stampCode,
    title,
    stampSize = 24,
    isMultiLineAllowed = true
  } = _ref;
  return /*#__PURE__*/_react.default.createElement("div", {
    style: {
      display: "flex",
      flexDirection: "row",
      alignItems: "center",
      // see https://css-tricks.com/flexbox-truncated-text/ for info about why we put minWidth on this
      // it turns out it is necessary to stop the display from being too large in a flex context
      minWidth: 0
    }
  }, /*#__PURE__*/_react.default.createElement("div", {
    style: {
      display: "flex",
      alignItems: "center"
    }
  }, /*#__PURE__*/_react.default.createElement(_Stamp.Stamp, {
    size: stampSize,
    status: status,
    text: stampCode
  })), /*#__PURE__*/_react.default.createElement("div", {
    style: {
      display: "inline-block",
      paddingLeft: 8,
      ...(isMultiLineAllowed ? {
        maxWidth: "calc(100% - ".concat(stampSize, "px)"),
        wordWrap: "break-word"
      } :
      // add style to force a single line with truncation
      {
        overflow: "hidden"
      })
    }
  }, isMultiLineAllowed ? title : /*#__PURE__*/_react.default.createElement(_alloyReactTooltip.OverflowTooltip, {
    variant: _alloyReactTooltip.default.VARIANTS.DARK,
    content: title
  }, title)));
};
exports.TypeDisplay = TypeDisplay;
//# sourceMappingURL=TypeDisplay.js.map